module.exports = __webpack_public_path__ + "static/sebrene_lyrics-ac62025af432a35f72d0fdf86812f36a.jpg";